export default "assets/images/motif-map-aee9e594.png";